<script setup>
import { computed, defineProps } from 'vue'
import { cn } from '@/lib/utils'
import { ToastTitle } from 'radix-vue'

const props = defineProps({
  class: { type: String, default: '' }
})

const delegatedProps = computed(() => {
  // eslint-disable-next-line no-unused-vars
  const { class: _, ...delegated } = props
  return delegated
})
</script>

<template>
  <ToastTitle v-bind="delegatedProps" :class="cn('text-sm font-semibold', props.class)">
    <slot />
  </ToastTitle>
</template> 